<template><!-- 商品頁主視覺 -->
    <div class="kv">
        <div id="fixedAside">
            <p>選電子保單</p>
            <p class="large">加碼送</p>
            <div class="line"></div>
            <p> 萬元好禮 </p>
            <a href="https://www.tmnewa.com.tw/ec/events/FY24_luckydraw"
               class="link FY24_accu" target="_blank">了解更多</a>
        </div>
        <div class="kvTxt">
            <p>全新升級的</p>
            <h2>國內旅平險+旅遊不便險</h2>
            <h3>給你更好的選擇</h3>
        </div>
        <div class="container">
            <div class="btnArea center">
                <a href="#travelTheme" class="btn theme_accu" v-smooth-scroll="{ duration: 1000, offset: -321, container: '.scrollContainer' }">
                    <span>跟著旅程買</span>
                </a>
                <div class="btn go_accu" @click="goCount1">
                    <span>立即投保</span>
                </div>
            </div>
            <div class="otherBtn">
                <a :href="overseasURL" class="btn goOther overseas_accu" target="_blank">國外旅遊由此去</a>
            </div>
        </div>

    </div>
</template>

<script setup>
        import {onMounted, ref} from "vue";
import gtm from "@/utils/gtmDataLayer";
import {useRouter} from "vue-router";


        const router =  useRouter();
        const overseasURL= ref();
        const goCount1 = () =>{
            sendDataLayer();
            router.push('/count1');
        }
        const sendDataLayer = () =>{
            gtm.policyEvent('view_item', 400
                , null, null, null, null
                , 'optional_taiwan', '自行試算');
        }
        onMounted(()=> {
            overseasURL.value = location.href.replace('taiwan', 'overseas');
        })

</script>
<style lang="scss">
.kv {
  background: url("../../assets/KV.svg");
  background-color: #cde3f1;
  background-size: 100%;
  background-repeat: no-repeat;
  background-position: center top;
  padding: 0 0 5%;
  text-align: center;

  @media screen and (max-width: $medium) {
    background-size: cover;
  }
  @media screen and (max-width: $pad) {
    margin-top: 61px;
    background: url("../../assets/kv_m.svg");
    background-size: cover;
    height: 90vh;
    background-position: center bottom;
    background-repeat: no-repeat;
    background-color: #cceff2;
  }
  @media screen and (max-width: $small) {
    height: 73vh;
    padding: 0 0 30%;
  }

  .bg {
    position: relative;
    top: 0;
    z-index: 10;
  }

  .title {
    display: inline-block;
    margin: 0 auto;
    padding: 3% 0 0;

    @media screen and (max-width: $padLandscape) {
      width: 60%;
    }
    @media screen and (max-width: $padMini) {
      width: 90%;
      padding: 30% 0 10%;
    }


  }

  .btnArea {
    margin: 50px 0 25px;
    @media screen and (max-width: $padMini) {
      margin: 0 0 20px;
      span{
          display: inline-block;
          width: 80%;
          text-align: center;
      }
    }
  }

  .btn.goOther {
    background: url(../../assets/goOther.svg);
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    color: $blue-700;
    width: 180px;
    padding: 0 5px;
    height: 60px;
    line-height: 60px;
    font-size: 18px;
    box-sizing: border-box;
    font-weight: bold;
    border-radius: inherit;text-indent: -5px;
    @media screen and (max-width: $padMini) {
      width: 55%;
      height: 55px;
      line-height: 55px;
      font-size: 16px;
    }
  }

  @media screen and (max-width: $small) {
    .btn {
      width: 40%;
      font-size: 16px;
      padding: 10px;
      box-sizing: border-box;
      margin: 0 8px;
      position: relative;

      img {
        position: absolute;
        right: 10px;
        top: 12px;
        width: 20px;
      }
    }

  }

  #fixedAside {
    position: fixed;
    top: 15%;
    right: 0;
    z-index: 100;
    color: #fff;
    font-size: 17px;
    background: $blue-700;
    box-sizing: border-box;
    padding: 10px;
    font-weight: 500;
    text-align: center;
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
    @media screen and (max-width: $pad){
        top:25%;
    }
    @media screen and (max-width: $padMini) {
      padding: 5px;
      right: inherit;
      top: inherit;
      bottom: 0;
      width: 100%;
      border-bottom-left-radius: 0;
      border-top-right-radius: 10px;
      font-size: 14px;
      p {
        display: inline-block;
      }
      .line {
        display: none;
      }
    }

    @media screen and (max-width: $small) {
      border-top-right-radius: 20px;
      border-top-left-radius: 20px;
      padding: 0;

    }

    .large {
      font-size: 25px;
      @media screen and (max-width: $padMini) {
        font-size: 14px;
      }
    }

    .line {
      border-bottom: 1px solid #fff;
      width: 99%;
      margin: 10px auto;
      position: relative;

      &:after {
        content: "";
        width: 5px;
        height: 5px;
        background: #fff;
        border-radius: 5px;
        position: absolute;
        right: 0;
        top: 1px;
      }

      &:before {
        content: "";
        width: 5px;
        height: 5px;
        background: #fff;
        border-radius: 5px;
        position: absolute;
        left: 0;
        top: 1px;
      }
    }

    .link {
      background: $yellow;
      color: #fff;
      padding: 5px 10px;
      box-sizing: border-box;
      text-decoration: none;
      margin: 10px 0;
      display: inline-block;
      border-radius: 50px;
        color:$textColor;
      @media screen and (max-width: $padMini) {
        width: 20%;
        margin: 5px 0;
        padding: 3px 0;
        margin-left: 5px;
      }
      @media screen and (max-width: $small) {
        font-size: 3vw;
      }
    }
  }
    .kvTxt{
        margin:0 auto;padding:3% 0 0;text-align:center;color:$blue-700;
        p{font-weight:bold;margin:0;font-size:60px;}
        h2{color:$yellow;margin:0;letter-spacing: 1px;font-size:60px;}
        h3{margin:0;letter-spacing: 1px;;clear: both;font-size:60px;
        }
        @media screen and (max-width: $pad) {
            width: 84%;
            padding:20% 0 3%;
            p{font-size:2rem}
            h2{font-size:2rem;}
            h3{font-size: 2rem;}
        }
        @media screen and (max-width: $padMini) {
            width: 88%;
            padding:15% 0 10%;
        }
        @media screen and (max-width: $small) {
            padding:28% 0 8%;
            p{font-size:1.6rem}
            h2{font-size:1.6rem;}
            h3{font-size: 1.6rem;}
        }


    }
}
</style>
